import { SET_PAGE_INFO, SET_SITE_SETTINGS } from './types';
import api from "../utils/api";

export const send = (settings) => dispatch => {
  dispatch({
    type: SET_PAGE_INFO,
    payload: settings
  });
};

export const settings = () => async (dispatch) => {
  try {
    const params = new URLSearchParams(window.location.search || "");
    const instance = params.get("i");
    const host = window?.location?.host || "";
    let result = await api.get(`/instances?h=${encodeURIComponent(host)}`);

    if (result?.data?.success === false && instance) {
      result = await api.get(`/instances?i=${encodeURIComponent(instance)}`);
    }

    dispatch({
      type: SET_SITE_SETTINGS,
      payload: result?.data
    });
    return result?.data;
  } catch (error) {
    return false;
  }
}
